import _ from 'lodash';
import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { useIsMobile } from '../../../shared/theme';
import { propTypes, defaultProps } from '../prop-types';
import AnimatedContactForm from './animated-contact-form';

const AdditionalMobileStyles = createGlobalStyle`
  .lead-capture-form-body {
    flex-direction: column;

    > .lead-capture-form-column.--left {
      margin-right: 0px;
      margin-bottom: 12px;
    }
  }
`;

export default function ContactForm({
  profile, wire, investorTypes,
}) {
  const isMobile = useIsMobile();
  const formProps = {
    investorTypes,
    organization: profile.organization,
    partnershipId: _.get(profile, 'activePartnership.id'),
    wireId: _.get(wire, 'id'),
    wireTitle: _.get(wire, 'title'),
    wireUrl: _.get(wire, 'url'),
  };

  return (
    <>
      {!!isMobile && <AdditionalMobileStyles />}
      <AnimatedContactForm {...formProps} />
    </>
  );
}

ContactForm.propTypes = propTypes;
ContactForm.defaultProps = defaultProps;
